export default __webpack_public_path__ + "static/media/me-longbeach.ff6a565f.jpg";